export interface LogoutDto
{
    getRefreshToken(): string;
}

export class LogoutDtoImpl implements LogoutDto
{
    private refreshToken: string;

    getRefreshToken(): string 
    {
        return this.refreshToken;
    }
    setRefreshToken(refreshToken: string)
    {
        this.refreshToken = refreshToken;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/logout/logoutdto.tsx